import { debounce, TextField } from "@mui/material";
import { getCustomerRecipients } from "api/customer";
import { getCheckZipcodeAvability } from "api/order";
import Select from "Components/FormControl/Select/NewSelect";
import { OrderConfigContext } from "Context/OrderConfigContext";
import { useFormikContext } from "formik";
import { formatUsPhone } from "Hooks/commanUtility";
import { getLabel } from "Hooks/getLabel";
import React, { useCallback, useContext, useEffect, useMemo, useState } from "react";
import Dropdown from "./Dropdown";
import DropdownLoqate from "./DropdownLoqate";
import { useLoqate } from "../hooks/useLoqate";
import _ from "lodash";
import PhoneInput from "react-phone-input-2";
import { PAYMENT_METHOD_DETAIL, DEFAULT_COUNTRY_CODE_NAME, PAYMENT_METHODS, ORDER_SOURCE, DEFAULT_TIMEZONE } from "Helpers/Constants";
import { isRefundSupported } from "Helpers/refundSupport";
import PhoneNumber from "Components/FormControl/PhoneNumber/PhoneNumber";
import { useOrderAttributeProvider } from "../context/order";
import { AppContext } from "Context/AppContext";
import { keepNumbersOnly, removePlusAndSpace, validateNotAllowStoreOrder } from "../utility/util";
import { validateTwilioPhoneNumber } from "api/util";
import CheckBox from "Components/FormControl/CheckBox/CheckBox";

const Recipent = ({ index, ...props }) => {
  const formik = useFormikContext();
  const config = useContext(OrderConfigContext);
  const { orderDetail,module } = useOrderAttributeProvider();
  const [overriddenPhoneNumber, setOverriddenPhoneNumber] = useState(false);
  const { showToastMessage } = useContext(AppContext);

  const { fetchAddressList, items, onItemClick, show, setItems } = useLoqate({
    onResult: (item) => {
      let BuildingNumber = item.BuildingNumber ? item.BuildingNumber + " " : "";
      let BuildingName = item.BuildingName ? item.BuildingName + " " : "";
      let Street = item.Street ? item.Street + " " : "";
      let apt = item.SubBuilding ?? "";
      let delivery_information = { ...formik.values.delivery_information };
      delivery_information.address_line_1 =
        BuildingNumber + BuildingName + Street;
      delivery_information.address_line_2 = apt;
      delivery_information.city = item.City ?? "";
      delivery_information.attn = item.Line2;
      delivery_information.state = item.Province ?? "";
      delivery_information.zipcode =
        (item.PostalCode.includes("-")
          ? item.PostalCode.split("-")[0]
          : item.PostalCode) ?? "";
      formik.setValues((v) => {
        return {
          ...v,
          delivery_information,
          is_initial_load: false,
        };
      });
    },
  });

  const [recipientList, setRecipientList] = useState([]);

  const [showDropDown, setShowDropDown] = useState(false);

  let touched = formik?.touched?.recipients
    ? formik?.touched.recipients[index] || {}
    : {};
  let errors = formik?.errors?.recipients
    ? formik?.errors?.recipients[index] || {}
    : {};

  let labels = useMemo(() => {
    return getLabel(formik.values.delivery_information.address_type);
  }, [formik.values.delivery_information.address_type_id]);

  //PAYABLI
  /**
   * Validates if an order can be edited when changing stores.
   * @param {Object} orderDetails - The current order details object
   * @returns {boolean} - Returns true if the order can be edited, false otherwise
   *
   * The API marks each transaction with refund_supported. Orders charged on a
   * processor that cannot refund them stay locked to their store.
   */
  const validateEditOrderForStoreChange = (orderDetails) => {
    return !isRefundSupported(
      orderDetails?.order_transaction?.order_payment_transactions?.[0]
    );
  };

  const handleLocalCheck = React.useCallback(() => {
    if(module === "edit-order" && formik.values.is_initial_load){
      return;
    }
    
    if (formik.values.delivery_information.zipcode.length === 5 && 
        formik.values.delivery_information.order_type !== 1) {
      //PAYABLI
      let data = formik.values.delivery_information.zipcode;
      getCheckZipcodeAvability(data).then((c) => {
        let local = false;
        let payment_method = formik.values.billing_info.payment_method;
        let di = { ...formik.values.delivery_information };
        let billing_info = { ...formik.values.billing_info };
        if(c.data){
          local = c.data.is_locally_available ? 1 : 0;
          payment_method =  PAYMENT_METHOD_DETAIL[c.data?.store_id ?? 0] ? PAYMENT_METHOD_DETAIL[c.data?.store_id ?? 0] : PAYMENT_METHODS.PAYABLI;
          billing_info.zip_code_store_id = c?.data?.store_id;
          formik.values.billing_info.zip_code_store_id = c?.data?.store_id;
          formik.values.delivery_information.is_local = c.data.is_locally_available ? 1 : 0;
          billing_info.payment_method = payment_method;
          di.is_local = local;
          const orderTimezone = c?.data?.timezone || DEFAULT_TIMEZONE;
          //PAYABLI
          const isValidateEditOrderForStoreChange = module === "edit-order" &&
              validateEditOrderForStoreChange(orderDetail);
          const isvalidateNotAllowStoreOrder = validateNotAllowStoreOrder(payment_method, c?.data?.payabli_paypoint, c.data?.store_id);
          if(isvalidateNotAllowStoreOrder){
            showToastMessage(
              undefined,
              "Currently, we are not accepting online orders for the selected location. However, we will start soon.", 
              "error", 
              false
            );
            di.zipcode = "";
            billing_info.zip_code_store_id = null;
            billing_info.payment_method = "";
            formik.setValues((v) => {
              return {
                ...v,
                orderTimezone,
                delivery_information: di,
                billing_info,
                payment_type: module === "edit-order" || module === "replace-order"? v.payment_type : "",
                payabli_paypoint: null
              };
            });
            return;
          } else if(isValidateEditOrderForStoreChange){
            showToastMessage(
              undefined,
              "This service is not available in the entered zip code area. Please enter a valid zip code to proceed.", 
              "error", 
              false
            );
            formik.setValues((v) => {
              return {
                ...v,
                orderTimezone,
                delivery_information:{
                  ...v.delivery_information,
                  zipcode: "",
                },
              };
            });
            return;
          }
          formik.setValues((v) => {
            return {
              ...v,
              orderTimezone,
              delivery_information: di,
              billing_info,
              //PAYABLI
              payment_type: module === "edit-order" || module === "replace-order"? v.payment_type : "",
              payabli_paypoint: c?.data?.payabli_paypoint
            };
          });
        }else{
          di.is_local = local;
          formik.setValues((v) => {
            return {
              ...v,
              delivery_information: di,
            };
          });
        }
      }).catch((error) => {
        // Clear the zip so the CSR re-enters it and the check runs again.
        showToastMessage(undefined, error.message, "error", false);
        formik.setFieldValue("delivery_information.zipcode", "");
      });
    }
  }, [formik.values.delivery_information.zipcode, formik.values.delivery_information.delivery_type]);

  useEffect(() => {
    handleLocalCheck();
  }, [handleLocalCheck]);

  const checkDelivery = React.useCallback(() => {
    if (!formik.values.delivery_information.is_local) {
      let products = formik.values.recipients[index].products
        ?.filter((c) => c?.is_local_only)
        ?.map((z) => z.title);
      let addons = formik.values.recipients[index].addons
        ?.filter((c) => c?.is_local_only)
        ?.map((z) => z.title);
      if (products?.length !== 0 || addons?.length !== 0) {
        formik.setValues((v) => {
          return {
            ...v,
            delivery_information: {
              ...v.delivery_information,
              not_deliverable: [...products, ...addons],
            },
          };
        });
      } else {
        formik.setValues((v) => {
          return {
            ...v,
            delivery_information: {
              ...v.delivery_information,
              not_deliverable: [],
            },
          };
        });
      }
    } else {
      formik.setValues((v) => {
        return {
          ...v,
          delivery_information: {
            ...v.delivery_information,
            not_deliverable: [],
          },
        };
      });
    }
  }, [
    formik.values.delivery_information.is_local,
    formik.values.recipients[index].addons,
    formik.values.recipients[index].products,
  ]);

  useEffect(() => {
    checkDelivery();
  }, [checkDelivery]);
  //Create unique key for each recipient
  useEffect(() => {
    let recipients = [...formik.values.recipients];
    recipients[index].recipient_key = recipients[index].recipient_key || 
     `reci_0_${index}_${new Date().getTime()}`;  // {reci_{order_index}_{recipient_index}}
    formik.setValues((v) => {
      return {
        ...v,
        recipients,
      };
    });
  },[formik.values.delivery_information.zipcode, formik.values.delivery_information.order_type]);

  const fetchRecipientList = React.useCallback(
    debounce(async (value) => {
      if (formik?.values?.customer_info?.customer_id !== 0) {
        const resp = await getCustomerRecipients({
          customer_id: formik.values.customer_info.customer_id,
          globalSearch: value,
        });
        setRecipientList(resp.data.data.rows);
      }
    }, 1000),
    [formik.values.customer_info.customer_id]
  );

  const setRecipient = (recipient) => {
    let recipients = [...formik.values.recipients];
    let delivery_information = { ...formik.values.delivery_information };
    recipients[index].recipient_id = recipient.id;
    recipients[index].first_name = recipient.first_name;
    recipients[index].last_name = recipient.last_name;

    delivery_information.address_line_1 = recipient.address_line_1;
    delivery_information.address_line_2 = recipient.address_line_2;
    delivery_information.city = recipient.city;
    delivery_information.state = recipient.state;
    delivery_information.zipcode = recipient.zipcode;
    delivery_information.phone = recipient.phone;
    delivery_information.alt_phone = recipient.alt_phone;
    delivery_information.address_type_id = recipient.address_type_id;
    delivery_information.address_type = recipient.address_type;
    formik.setValues((v) => {
      return {
        ...v,
        recipients,
        delivery_information,
      };
    });
  };

 // we are Manage Order Transection data and filter 0 order id transection
 const order_payment_transactions_data =  formik.values?.order_payment_transactions?.filter((val) => val.order_id === 0) || []
 const payment_method = order_payment_transactions_data?.length > 0 && order_payment_transactions_data[0]?.payment_method
 const isDisebled = formik.values.source === ORDER_SOURCE.WALKIN?.toLowerCase() && payment_method === PAYMENT_METHODS.PAYABLI ? true : false

 // validate twilio phone number on first load
 useEffect(() => {
  // validate twilio phone number for recipient phone
    const validateTwilioRecipientOnFirstLoad = async () => {
      if(formik?.values?.delivery_information?.phone && module !== "edit-order"){
      let delivery_information = { ...formik.values.delivery_information };
      let phoneCountryCode = keepNumbersOnly(delivery_information?.phone_country_code);
      let phoneNumber = keepNumbersOnly(delivery_information?.phone);
      let is_valid_phone_number = delivery_information?.is_valid_phone_number;
      //Prevents multiple API calls for the same phone number
        if(phoneNumber && phoneNumber.length >= 10  && !overriddenPhoneNumber && !is_valid_phone_number){
          // Call API to validate twilio phone number
          const response = await validateTwilioPhoneNumber({ 
            phone_number: [{phone:phoneCountryCode+phoneNumber, id:1}]
          });
          let is_valid_phone_number = response?.data?.data?.is_valid;
          // If phone number is not valid, show overridden phone number
          
          if(!is_valid_phone_number){
            delivery_information['is_show_overridden_phone_number'] = true;
            delivery_information['is_valid_phone_number'] = is_valid_phone_number;
            formik.setValues((v) => {
              return {
                ...v,
                delivery_information: delivery_information,
              };
            });
            //This the fallback for the formik values
            if(!formik.values.delivery_information.is_show_overridden_phone_number){
              formik.values.delivery_information.is_show_overridden_phone_number = true;
              formik.values.delivery_information.is_valid_phone_number = false;
            }
          } else{
            // If phone number is valid, hide overridden phone number
            delivery_information['is_show_overridden_phone_number'] = false;
            delivery_information['is_valid_phone_number'] = true;
            formik.setValues((v) => {
              return {
                ...v,
                delivery_information: delivery_information,
              };
            });
            //This the fallback for the formik values
            if(!formik.values.delivery_information.is_valid_phone_number ){
              formik.values.delivery_information.is_valid_phone_number = true;
              formik.values.delivery_information.is_show_overridden_phone_number = false;
            }
          }
        } else{
          // Only reset if phone number is too short
          // Don't reset if is_valid_phone_number is already true (from previous API call)
          // The else block runs when: phoneNumber is falsy OR length < 10 OR overriddenPhoneNumber is true OR is_valid_phone_number is already true
          if(!phoneNumber || phoneNumber.length < 10 || !is_valid_phone_number){
            // Phone number is too short or missing, reset validation
            delivery_information['is_show_overridden_phone_number'] = false;
            delivery_information['is_valid_phone_number'] = false;
            formik.setValues((v) => {
              return {
                ...v,
                delivery_information: delivery_information,
              };
            });
            setOverriddenPhoneNumber(false);
          }
        }
      }
    }
    validateTwilioRecipientOnFirstLoad();
  }, [formik?.values?.delivery_information.phone]);

 // show overridden phone number if is_show_overridden_phone_number is true
 const isShowOverriddenPhoneNumber = formik.values?.delivery_information?.is_show_overridden_phone_number || false;

  return (
    <div className={`row recform ${props.className}`}>
      <div className="col-md-6 mr-5">
        <Select
          error={
            touched?.whats_the_occasion && Boolean(errors?.whats_the_occasion)
          }
          label="What's the occasion"
          value={formik.values.recipients[index].whats_the_occasion_id}
          required={true}
          isSearchable={false}
          //
          onChange={(data) => {
            let recipients = [...formik.values.recipients];
            recipients[index].whats_the_occasion_id = data.id;
            recipients[index].whats_the_occasion = data.name;
            formik.setValues((v) => {
              return {
                ...v,
                recipients,
              };
            });
          }}
          blur={formik.handleBlur}
          touched={formik.touched.whats_the_occasion_id}
          disabled={isDisebled}
          id={`recipients[${index}].whats_the_occasion_id`}
          options={config?.occasionsList}
        />
      </div>
      <div className="col-md-6 my-2">
        <TextField
          onFocus={() => {
            setShowDropDown(true);
          }}
          error={touched?.first_name && Boolean(errors?.first_name)}
          helperText={touched?.first_name && errors?.first_name}
          onChange={(e) => {
            formik.handleChange(e);
            fetchRecipientList(e.target.value);
          }}
          onBlur={(e) => {
            setTimeout(() => {
              setShowDropDown(false);
              setRecipientList([]);
            }, 100);
            formik.handleBlur(e);
          }}
          className="w-100"
          label="First Name"
          name={`recipients[${index}].first_name`}
          //  we are manage fields using Order payment_method and order Type 
          disabled={isDisebled}
          value={formik.values.recipients[index].first_name}
          variant="standard"
        />
        <Dropdown
          recipientList={recipientList}
          showDropDown={showDropDown}
          onItemClick={(recipient) => setRecipient(recipient)}
        />
      </div>
      <div className="col-md-6 my-2">
        <TextField
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={touched?.last_name && Boolean(errors?.last_name)}
          helperText={touched?.last_name && errors?.first_name}
          className="w-100"
          name={`recipients[${index}].last_name`}
          //  we are manage fields using Order payment_method and order Type 
          disabled={isDisebled}
          value={formik.values.recipients[index].last_name}
          label="Last Name"
          variant="standard"
        />
      </div>
      <div className="col-md-6" style={{ marginTop: 14 }}>
        <Select
          isSearchable={false}
          label="Address Type"
          value={formik.values.delivery_information.address_type_id}
          required={true}
          //  we are manage fields using Order payment_method and order Type 
          disabled={ isDisebled || formik.values.delivery_information.order_type === 1 || index > 0 }
          onChange={(data) => {
            let di = { ...formik.values.delivery_information };
            di.address_type_id = data.id;
            di.address_type = data.name;
            di = {
              ...di,
              delivery_date: null,
              delivery_time_id: null,
              delivery_time: "",
              delivery_date_time: "",
              delivery_time_type: "",
              delivery_type: "",
              actual_delivered_time: "",
              charge: 0,
              upcharge_id: 0,
              upcharge_amount: 0,
            };
            formik.setValues((v) => {
              return {
                ...v,
                delivery_information: di,
              };
            });
          }}
          blur={formik.handleBlur}
          touched={formik?.touched?.delivery_information?.address_type_id}
          error={formik.errors?.delivery_information?.address_type_id}
          id="delivery_information.address_type_id"
          options={config.addressTypesList}

        />
      </div>
      <div className="col-md-6  my-2">
        <TextField
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          className="w-100"
          value={formik.values.delivery_information.attn}
          name={`delivery_information.attn`}
          //  we are manage fields using Order payment_method and order Type 
          disabled={ isDisebled || formik.values.delivery_information.order_type === 1 || index > 0 }
          label={labels.attnLabel}
          variant="standard"
        />
      </div>
      <div className="col-12 my-2">
        <TextField
        //  we are manage fields using Order payment_method and order Type 
          disabled={ isDisebled || formik.values.delivery_information.order_type === 1 || index > 0 }
          onKeyDown={(e) => {
            if (e.key === "Tab") {
              setItems([]);
            }
          }}
          onChange={(e) => {
            formik.handleChange(e);
            fetchAddressList(e.target.value);
          }}
          onBlur={formik.handleBlur}
          error={
            formik.touched?.delivery_information?.address_line_1 &&
            Boolean(formik.errors.delivery_information?.address_line_1)
          }
          helperText={
            formik.touched?.delivery_information?.address_line_1 &&
            formik.errors.delivery_information?.address_line_1
          }
          className="w-100"
          value={formik.values.delivery_information.address_line_1}
          name={`delivery_information.address_line_1`}
          label="Address Line 1"
          variant="standard"
        />
        <DropdownLoqate
          addressList={items}
          showDropDown={show}
          onItemClick={onItemClick}
        />
      </div>
      <div className="col-12 my-2">
        <TextField
        //  we are manage fields using Order payment_method and order Type 
          disabled={ isDisebled || formik.values.delivery_information.order_type === 1 || index > 0 }
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          className="w-100"
          label={labels.addressLine2Label}
          value={formik.values.delivery_information.address_line_2}
          name={`delivery_information.address_line_2`}
          variant="standard"
        />
      </div>
      <div className="col-4 my-2">
        <TextField
        //  we are manage fields using Order payment_method and order Type 
          disabled={ isDisebled || formik.values.delivery_information.order_type === 1 || index > 0 }
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            formik.touched?.delivery_information?.city &&
            Boolean(formik.errors.delivery_information?.city)
          }
          helperText={
            formik.touched?.delivery_information?.city &&
            formik.errors.delivery_information?.city
          }
          className="w-100"
          label="City"
          value={formik.values.delivery_information.city}
          name={`delivery_information.city`}
          variant="standard"
        />
      </div>
      <div className="col-4 my-2">
        <TextField
        //  we are manage fields using Order payment_method and order Type 
          disabled={ isDisebled || formik.values.delivery_information.order_type === 1 || index > 0 }
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={
            formik.touched?.delivery_information?.state &&
            Boolean(formik.errors.delivery_information?.state)
          }
          helperText={
            formik.touched?.delivery_information?.state &&
            formik.errors.delivery_information?.state
          }
          className="w-100"
          label="State"
          value={formik.values.delivery_information.state}
          name={`delivery_information.state`}
          variant="standard"
        />
      </div>
      <div className="col-4 my-2">
        <TextField
        //  we are manage fields using Order payment_method and order Type 
          disabled={ isDisebled || formik.values.delivery_information.order_type === 1 || index > 0 }
          onChange={(e) => {
            // Set is_initial_load to false when zipcode is changed in edit order module
            // Or anything changes related to zipcode
            formik.values.is_initial_load = false;

            let de = { ...formik.values.delivery_information };
            if (e.target.value.length > 5) return;
            de.zipcode = e.target.value;
            const orderType = formik.values.delivery_information.order_type;
            de = {
              ...de,
              delivery_date: null,
              delivery_time_id: null,
              delivery_time: "",
              delivery_date_time: "",
              delivery_time_type: "",
              delivery_type: "",
              actual_delivered_time: "",
              charge: 0,
              upcharge_id: 0,
              upcharge_amount: 0,
            };
            formik.setValues((v) => {
              return {
                ...v,
                delivery_information: de,
                billing_info: {
                  ...v.billing_info,
                  zip_code_store_id: orderType === 0 && e.target.value?.length < 5 ? null: v.billing_info.zip_code_store_id,
                  payment_method: orderType === 0 && e.target.value?.length < 5 ? null: v.billing_info.zip_code_store_id,
                },
              };
            });
          }}
          onBlur={formik.handleBlur}
          error={
            formik.touched?.delivery_information?.zipcode &&
            Boolean(formik.errors.delivery_information?.zipcode)
          }
          helperText={
            formik.touched?.delivery_information?.zipcode &&
            formik.errors.delivery_information?.zipcode
          }
          className="w-100"
          label="Zipcode"
          value={formik.values.delivery_information.zipcode}
          name={`delivery_information.zipcode`}
          variant="standard"
        />
      </div>
      <div className="col-md-6 my-2">
        <PhoneNumber
          countryCode={DEFAULT_COUNTRY_CODE_NAME}
          initValue={
            formik.values.delivery_information?.phone_country_code +
            formik.values.delivery_information?.phone
          }
          specialLabel={"Phone"}
          fieldName={`delivery_information.phone`}
          onChange={async (phone, countryData, event, formatedValue) => {
            let countryCode = "+" + countryData.dialCode;
            let finalMobileNum = formatedValue
              ? formatedValue?.split(countryCode)[1]?.trim()
              : "";
            let valueUpdate = {
              ...formik.values.delivery_information,
              phone: finalMobileNum,
              phone_country_code: countryCode,
            };
            formik.setValues((v) => {
              return {
                ...v,
                delivery_information: valueUpdate,
              };
            });
          }}
          //  we are manage fields using Order payment_method and order Type 
          disabled={ isDisebled || index > 0 }
        />
        {isShowOverriddenPhoneNumber && module !== "edit-order" && (
          <div style={{ marginTop: "-18px" }}>
            <CheckBox
              value={overriddenPhoneNumber}
              label="Override phone number"
              onChange={(data) => {
                setOverriddenPhoneNumber(data);
                formik.setValues((v) => ({
                  ...v,
                  delivery_information: { ...formik.values.delivery_information, is_valid_phone_number: data },
                }));
              }}
            />
          </div>
        )}
      </div>
      <div className="col-md-6 my-2">
        <PhoneNumber
          countryCode={DEFAULT_COUNTRY_CODE_NAME}
          initValue={
            formik.values.delivery_information?.alt_phone_country_code +
            formik.values.delivery_information?.alt_phone
          }
          specialLabel={"Alt Phone"}
          fieldName={`delivery_information.alt_phone`}
          onChange={(phone, countryData, event, formatedValue) => {
            let countryCode = "+" + countryData.dialCode;
            let finalMobileNum = formatedValue
              ? formatedValue?.split(countryCode)[1]?.trim()
              : "";
            let valueUpdate = {
              ...formik.values.delivery_information,
              alt_phone: finalMobileNum,
              alt_phone_country_code: countryCode,
            };
            formik.setValues((v) => {
              return {
                ...v,
                delivery_information: valueUpdate,
              };
            });
          }}
          //  we are manage fields using Order payment_method and order Type 
          disabled={ isDisebled || index > 0 }
        />
      </div>
    </div>
  );
};

export default Recipent;
